import {Action} from '@ngrx/store';
import {Moment} from 'moment';
import {ShiftTemplate} from '@app/core/models/shift-template.model';

export enum EShiftTemplatesActions {
	SetCopyingWeek = '[Schedule] Set Copying Week',
	GetTemplates = '[Schedule] Get Templates',
	GetTemplatesSuccess = '[Schedule] Get Templates Success',
	PostCopyingWeek = '[Schedule] Post CopyingWeek',
	PostCopyingWeekSuccess = '[Schedule] Post CopyingWeek Success',
	CreateShiftTemplate = '[Schedule] Create Shift Template',
	CreateShiftTemplateSuccess = '[Schedule] Create Shift Template Success',
	DeleteShiftTemplate = '[Schedule] Delete Shift Template',
	DeleteShiftTemplateSuccess = '[Schedule] Delete Shift Template Success',
	InsertShiftTemplate = '[Schedule] Insert Shift Template',
	InsertShiftTemplateSuccess = '[Schedule] Insert Shift Template Success',
}

export class SetCopyingWeek implements Action {
	public readonly type = EShiftTemplatesActions.SetCopyingWeek;

	constructor(public copyingWeek: any[]) {
	}
}

export class GetTemplates implements Action {
	public readonly type = EShiftTemplatesActions.GetTemplates;

	constructor(public departmentId: number) {
	}
}

export class GetTemplatesSuccess implements Action {
	public readonly type = EShiftTemplatesActions.GetTemplatesSuccess;

	constructor(public templates: any[]) {
	}
}

export class PostCopyingWeek implements Action {
	public readonly type = EShiftTemplatesActions.PostCopyingWeek;

	constructor(
		public copyingWeek: any[],
		public startDate: Moment,
	) {
	}
}

export class PostCopyingWeekSuccess implements Action {
	public readonly type = EShiftTemplatesActions.PostCopyingWeekSuccess;

	constructor() {
	}
}

export class CreateShiftTemplate implements Action {
	public readonly type = EShiftTemplatesActions.CreateShiftTemplate;

	constructor(public shiftTemplate: ShiftTemplate, public departmentId: number) {
	}
}

export class CreateShiftTemplateSuccess implements Action {
	public readonly type = EShiftTemplatesActions.CreateShiftTemplateSuccess;

	constructor(public shiftTemplate: ShiftTemplate) {
	}
}

export class DeleteShiftTemplate implements Action {
	public readonly type = EShiftTemplatesActions.DeleteShiftTemplate;

	constructor(public shiftTemplateId: number) {
	}
}

export class DeleteShiftTemplateSuccess implements Action {
	public readonly type = EShiftTemplatesActions.DeleteShiftTemplateSuccess;

	constructor(public shiftTemplateId: number) {
	}
}

export class InsertShiftTemplate implements Action {
	public readonly type = EShiftTemplatesActions.InsertShiftTemplate;

	constructor(public shiftTemplate: ShiftTemplate, public startDate: Moment) {
	}
}

export class InsertShiftTemplateSuccess implements Action {
	public readonly type = EShiftTemplatesActions.InsertShiftTemplateSuccess;

	constructor() {
	}
}

export type ShiftTemplatesActions =
	SetCopyingWeek |
	GetTemplates |
	GetTemplatesSuccess |
	PostCopyingWeek |
	PostCopyingWeekSuccess |
	CreateShiftTemplate |
	CreateShiftTemplateSuccess |
	DeleteShiftTemplate |
	DeleteShiftTemplateSuccess |
	InsertShiftTemplate |
	InsertShiftTemplateSuccess
	;
